var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 5.54167V1.16955C5.83333 0.523626 6.35117 0 7 0C7.64433 0 8.16667 0.531721 8.16667 1.16955V5.54167H12.8304C13.4764 5.54167 14 6.05951 14 6.70833C14 7.35267 13.4683 7.875 12.8304 7.875H8.16667V12.8304C8.16667 13.4764 7.64882 14 7 14C6.35567 14 5.83333 13.4683 5.83333 12.8304V7.875H1.16955C0.523626 7.875 0 7.35716 0 6.70833C0 6.064 0.531721 5.54167 1.16955 5.54167H5.83333Z",
    fill: "#01459D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.099f0ad04f4090da1f102076eff8ed7a.svg";
export { ForwardRef as ReactComponent };